import * as React from 'react';

import { cn } from '@/lib/utils';

interface CommentTriggerProps {
  count?: number;
  className?: string;
}

const BUBBLE_PATH =
  'M27.8125 2.4375V19.4375C27.8125 20.0011 27.5886 20.5416 27.1901 20.9401C26.7916 21.3386 26.2511 21.5625 25.6875 21.5625H17.6616L15.8448 24.742C15.6589 25.0672 15.3903 25.3374 15.0664 25.5254C14.7424 25.7133 14.3745 25.8123 14 25.8123C13.6255 25.8123 13.2576 25.7133 12.9336 25.5254C12.6097 25.3374 12.3411 25.0672 12.1552 24.742L10.3384 21.5625H2.3125C1.74891 21.5625 1.20841 21.3386 0.809898 20.9401C0.411383 20.5416 0.1875 20.0011 0.1875 19.4375V2.4375C0.1875 1.87391 0.411383 1.33341 0.809898 0.934898C1.20841 0.536383 1.74891 0.3125 2.3125 0.3125H25.6875C26.2511 0.3125 26.7916 0.536383 27.1901 0.934898C27.5886 1.33341 27.8125 1.87391 27.8125 2.4375Z';

const CommentTrigger = ({ count = 0, className }: CommentTriggerProps) => {
  const hasComments = count > 0;
  const label = hasComments ? String(count) : null;
  const digits = label?.length ?? 0;

  return (
    <span
      className={cn(
        'relative inline-flex h-[26px] items-center justify-center',
        hasComments ? 'min-w-[28px] px-1.5' : 'w-[28px]',
        digits > 2 && 'px-2',
        !hasComments && 'opacity-70',
        className,
      )}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 28 26"
        preserveAspectRatio="none"
        className="absolute inset-0 h-full w-full"
        aria-hidden
      >
        <path d={BUBBLE_PATH} fill="#B4BACD" />
      </svg>
      {hasComments ? (
        <span
          className={cn(
            'relative z-[1] -translate-y-[2px] font-bold leading-none text-white',
            digits > 2 ? 'text-[10px]' : 'text-xs',
          )}
        >
          {label}
        </span>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 28 26"
          className="relative z-[1] h-full w-full"
          aria-hidden
        >
          <path
            d="M11 12H17"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14 9V15"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </span>
  );
};

export default CommentTrigger;
